var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 453,
    height: 74,
    viewBox: "0 0 453 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.476 59.2329C390.19 59.7073 390.665 60.4203 391.14 61.1319C392.568 62.5565 395.66 65.88 397.324 66.3543C397.562 66.5915 397.324 66.3544 397.562 66.8287C397.562 66.8287 397.8 67.0659 398.037 67.0659C398.752 67.5403 398.275 67.0659 398.988 67.7789C400.415 68.2533 402.08 69.2035 403.507 69.6779C412.306 73.2386 421.581 73.2386 430.619 70.1523C432.998 69.4393 437.516 67.7775 438.705 65.8786L441.797 63.7424C446.079 60.6561 449.645 52.8231 451.309 47.1248C452.974 40.4792 453.212 30.7458 450.834 24.0988C448.455 17.4517 446.315 12.7036 440.845 7.95552C435.851 3.68181 430.381 1.30848 422.533 0.358291C391.616 -3.43961 377.347 23.6215 385.194 49.9725C385.669 51.3971 386.384 53.296 387.097 54.7206C387.811 56.3824 389.238 58.2813 389.476 59.2315V59.2329ZM415.637 23.3872C430.858 19.5893 433.711 46.6504 420.394 50.4497C413.022 52.3487 408.028 45.4645 407.315 39.5304C406.363 31.6974 409.217 25.049 415.637 23.3872Z",
    fill: "url(#paint0_linear_13337_21073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.75 71.1021C112.178 70.6277 114.318 61.6074 115.507 59.9456C117.647 59.9456 130.49 59.7084 131.441 60.1828C132.391 60.8958 133.581 67.3042 137.863 70.1533C143.57 73.9512 152.37 71.3407 155.461 66.5926C157.363 64.2193 155.461 61.3702 155.223 58.521C154.034 52.1112 152.131 46.4143 150.704 40.2416C148.802 32.17 143.332 12.9419 138.099 7.24503C131.916 0.599402 120.738 -0.587979 111.226 2.02255C105.994 3.44712 107.183 2.25974 105.279 7.24503C101.475 16.504 94.1024 41.6662 92.6753 51.6368C91.0105 64.4551 95.292 76.0874 110.75 71.1021ZM117.171 42.3792C117.171 40.4803 122.403 21.9637 123.355 21.2521C124.069 22.2009 126.684 29.5609 127.159 31.4599C127.872 34.0704 129.775 39.5315 129.775 42.3806H117.171V42.3792Z",
    fill: "url(#paint1_linear_13337_21073)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 20.7775C247.497 30.9853 246.782 47.8401 247.734 57.0977C248.448 65.1693 249.874 64.4563 250.113 66.8311C252.492 68.0184 251.778 70.3918 260.577 70.8661C266.524 71.1033 283.17 71.8164 288.402 69.6788C295.061 67.0683 294.349 63.0332 295.537 62.3202C295.061 58.7594 296.726 57.8093 293.872 52.1124C290.067 51.8752 270.566 52.5868 269.139 51.8752C268.425 50.925 268.901 45.9397 268.901 44.278C273.658 43.565 279.841 44.7524 284.36 44.0408C295.774 42.1418 291.494 30.2723 290.781 29.3235C289.829 28.3748 286.025 28.1362 284.36 28.1362C279.603 27.899 273.183 28.6106 268.664 28.1362V21.2519C275.56 20.3032 285.312 22.4393 291.257 20.0645C296.964 17.454 298.392 9.85681 296.251 2.97257C291.257 2.49819 250.351 1.54798 248.686 2.73536C247.972 3.44693 247.972 6.05888 247.972 7.24484C247.972 8.66941 247.734 10.3312 247.734 11.9929C247.736 14.3677 247.498 17.6912 247.498 20.7775H247.497Z",
    fill: "url(#paint2_linear_13337_21073)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.111 5.34544C165.921 9.61915 164.971 53.0593 165.921 63.5056C166.396 69.9155 174.007 73.7134 179.715 73.0004C183.757 72.526 185.422 71.1014 187.801 69.2025L189.228 40.241C190.893 40.954 201.595 57.8074 201.595 58.2817C203.735 59.7063 205.162 63.9786 207.541 65.166C207.779 66.1147 208.492 66.1148 209.444 67.3021V67.5393C209.444 67.5393 209.444 67.5393 209.444 67.7765C211.823 68.7253 214.2 71.3372 220.384 71.5744C223.952 71.5744 230.848 70.387 231.561 68.0137C233.701 55.194 233.464 13.4142 233.226 10.5665C232.036 0.83312 217.768 -2.25322 211.821 4.63102C210.871 5.8184 211.107 6.52997 211.346 8.42892C211.584 13.6514 210.156 36.6774 209.444 37.8648C208.729 37.3904 193.747 16.0247 192.083 13.6514C189.467 9.37769 187.088 4.63103 182.094 2.96927C179.479 2.0205 176.148 1.78188 173.057 2.49487C170.204 3.20786 167.587 5.10683 167.112 5.34402L167.111 5.34544Z",
    fill: "url(#paint3_linear_13337_21073)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.14 5.34544C306.951 9.61915 306 53.0593 306.951 63.5056C307.426 69.9155 315.037 73.7134 320.745 73.0004C324.787 72.526 326.452 71.1014 328.831 69.2025L330.258 40.241C331.923 40.954 342.625 57.8074 342.625 58.2817C344.765 59.7063 346.192 63.9786 348.571 65.166C348.809 66.1147 349.521 66.1148 350.473 67.3021V67.5393C350.473 67.5393 350.473 67.5393 350.473 67.7765C352.852 68.7253 355.23 71.3372 361.414 71.5744C364.981 71.5744 371.878 70.387 372.591 68.0137C374.731 55.194 374.493 13.4142 374.256 10.5665C373.066 0.83312 358.797 -2.25322 352.851 4.63102C351.899 5.8184 352.137 6.52997 352.376 8.42892C352.613 13.6514 351.186 36.6774 350.473 37.8648C349.759 37.3904 334.777 16.0247 333.112 13.6514C330.497 9.37769 328.118 4.63103 323.124 2.96927C320.508 2.0205 317.177 1.78188 314.087 2.49487C310.996 3.20786 308.617 5.10683 308.142 5.34402L308.14 5.34544Z",
    fill: "url(#paint4_linear_13337_21073)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7988 33.8322C25.134 43.8028 24.1835 64.4555 23.7068 65.1671C23.2316 71.1026 22.5173 72.5257 19.902 72.7643C13.2442 73.7131 -0.788487 69.2036 0.876313 57.8085L6.82264 12.7051C8.01219 7.48266 13.0066 4.39778 19.1891 2.26021C27.5117 -0.350317 32.0323 6.53391 38.2148 14.6041C38.69 15.0785 40.5939 15.3157 42.4963 15.3157C44.3987 15.3157 46.5388 15.0785 46.7778 14.6041C52.9618 6.53249 57.4795 -0.826121 65.8035 2.26021C71.9875 4.15916 76.7442 7.48266 78.17 12.7051L84.1163 57.8085C85.3059 69.2022 71.7498 73.7131 65.0906 72.7643C62.7115 72.7643 61.761 71.1026 61.2858 65.1671C61.0482 64.6927 60.0962 43.8014 58.1938 33.8322C57.9562 32.8835 57.4795 32.6448 56.7666 33.1192C54.3875 34.5438 51.7722 45.226 46.5402 48.5495C45.113 49.4982 39.6434 49.4982 38.2162 48.7867C32.5089 45.7003 30.6051 34.0694 27.7522 33.1192C27.5145 32.6448 27.0379 32.6448 26.8002 33.8322H26.7988Z",
    fill: "url(#paint5_linear_13337_21073)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7334 26.2376C41.7829 26.2376 40.5933 26.0004 40.3543 25.0503C40.3543 25.0503 40.3543 25.0503 40.1166 25.0503C30.8407 12.2305 15.3823 12.4692 7.29731 13.1807C7.05968 13.1807 6.58301 13.1807 6.58301 12.4691L7.05826 8.43407L12.2903 2.97437C12.5279 2.73718 12.7655 2.50001 13.9551 2.50001C30.8393 4.63616 41.5424 17.9302 42.4929 19.3534C43.4434 17.9288 54.1465 4.63616 71.0321 2.50001C71.9826 2.26282 72.4593 2.73718 72.6969 2.97437L77.9289 8.43407L78.4042 12.4691C78.4042 12.9435 78.1666 13.1807 77.6913 13.1807C69.844 12.4692 54.1465 12.4692 44.8706 25.0503C44.8706 25.0503 44.8706 25.0503 44.6329 25.0503C44.8734 25.7633 43.9215 26.2376 42.7319 26.2376H42.7334Z",
    fill: "#1BACE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7324 23.15C41.3052 17.6903 28.2245 5.82084 8.01065 8.43137C6.8211 8.66856 7.29636 7.95699 7.5354 7.71837L12.7674 2.4959C13.4817 1.7829 14.1946 1.07133 16.8099 0.834141C34.646 -0.353237 41.3052 12.9408 42.7324 14.6026C44.1596 12.9408 50.5797 -0.353237 68.6549 0.834141C71.034 1.07133 71.9845 1.7829 72.6974 2.4959L77.9294 7.71837C78.1671 7.95556 78.6423 8.66856 77.4542 8.43137C57.2375 5.81942 44.3944 17.6889 42.731 23.15H42.7324Z",
    fill: "#47C7EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13337_21073",
    x1: 365.5,
    y1: 14.4822,
    x2: 453.566,
    y2: 28.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13337_21073",
    x1: 76.1694,
    y1: 15.0465,
    x2: 157.447,
    y2: 26.7074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13337_21073",
    x1: 234.61,
    y1: 15.9641,
    x2: 298.537,
    y2: 23.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13337_21073",
    x1: 148.382,
    y1: 15.3499,
    x2: 234.411,
    y2: 28.3288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13337_21073",
    x1: 289.412,
    y1: 15.3499,
    x2: 375.441,
    y2: 28.3288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13337_21073",
    x1: -20.3566,
    y1: 15.8103,
    x2: 84.1878,
    y2: 35.4346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9eebb200a98110dfed9d873781478190.svg";
export { ForwardRef as ReactComponent };